import type { CountryRow } from "./types";
import { useData } from "./useData";

export interface CountryState {
  code?: string;
  name?: string;
  assignedTo?: string;
  assigned?: string;
  eliminated?: string | boolean;
  flag?: string;
  index?: number;
  error?: unknown;
  loading: boolean;
}

export function useCountry(code?: string): CountryState {
  const { countries, loading, error } = useData();
  const country = findCountry(countries, code);

  return { ...country, loading, error };
}

export function findCountry(
  countries: CountryRow[] = [],
  code?: string,
): CountryRow | undefined {
  const searchValue = normalizeCountryLookupValue(code);

  if (!searchValue) return undefined;

  return countries.find(
    (country) =>
      normalizeCountryLookupValue(country.code) === searchValue ||
      normalizeCountryLookupValue(country.name) === searchValue,
  );
}

function normalizeCountryLookupValue(value?: string): string {
  return value?.trim().toLocaleLowerCase() ?? "";
}
